import Vue from "vue"
import { beforeRouteEnter } from "@assets/js/routerPageHook.js"
import BannerBtnQuestionnaires from "@components/ui-components/banner-btn-questionnaires/component.js"
import formGreen from "@components/base/form-green.vue"
import reviewsItem from "@components/ui-components/reviews-item/component.js"
import numberService from "@components/ui-components/number-service/component.js"
import titleLink from "@components/ui-components/title-link/component.js"
import filterContainer from "@components/ui-components/filter-container/filter-container.vue"
import filterSearch from "@components/ui-components/filter-search/filter-search.vue"
import LoadMore from "@components/ui-components/load-more/load-more"
import caseService from "@components/ui-components/case-service/component.js"
import doubleBlock from "@components/ui-components/double-block/component.js"
import serviceIcons from "@components/ui-components/service-icons/component.js"
import serviceSlider from "@components/ui-components/service-slider/component.js"
import serviceCard from "@components/ui-components/service-card/component.js"
import serviceText from "@components/ui-components/service-text/component.js"
import serviceBlock from "@components/ui-components/service-block/component.js"
import onScrollAnimate from "@assets/js/scrollAnimate.js"
import { mapState } from "vuex"
import { router } from "@src/routes"

export default {
  name: "index",
  data() {
    return {
      template: "<main></main>",
      newRows: {},
      pagination: null,
      visibleVendor: null,
      currentFormName: null,
      disableLoadMore: false,
    }
  },
  components: {
    "banner-btn-questionnaires-cmp": BannerBtnQuestionnaires,
    "form-green-cmp": formGreen,
    "reviews-item-cmp": reviewsItem,
    "number-service-cmp": numberService,
    "title-link-cmp": titleLink,
    "filter-container-cmp": filterContainer,
    "filter-search-cmp": filterSearch,
    "load-more-cmp": LoadMore,
    "case-service-cmp": caseService,
    "double-block-cmp": doubleBlock,
    "service-icons-cmp": serviceIcons,
    "service-slider-cmp": serviceSlider,
    "service-card-cmp": serviceCard,
    "service-text-cmp": serviceText,
    "service-block-cmp": serviceBlock,
  },
  computed: {
    ...mapState("mobile", ["isMobile", "isTablet"]),
  },
  methods: {
    setCurrentFormName(value) {
      this.currentFormName = value
    },
    setPagination() {
      setTimeout(() => {
        this.pagination = this.$root.convertTwigToJs("pagination", ".js-pagination")
      }, 100)
    },
    openVendor(index) {
      if (this.visibleVendor === index) {
        this.visibleVendor = null
      } else {
        this.visibleVendor = index
      }
    },
  },
  mounted() {
    this.setPagination()
  },
  beforeRouteUpdate(to, from, next) {
    if (this.currentFormName && to.query[`${this.currentFormName}[loadMore]`]) {
      let url =
        process.env.NODE_ENV !== "production"
          ? "questionnaires/index.json"
          : document.querySelector(".js-pagination").getAttribute("data-pagination-url")

      Vue.http.get(url, { params: to.query }).then(
        data => {
          next()
          if (!this.newRows[this.currentFormName]) {
            this.newRows[this.currentFormName] = []
          }
          this.newRows[this.currentFormName] = this.newRows[this.currentFormName].concat(data.data.items)
          this.pagination = data.data.pagination
          setTimeout(() => {
            onScrollAnimate()
          }, 10)
        },
        () => {
          next("/404")
        }
      )
    } else {
      this.disableLoadMore = true
      const path = to.path.replace(router.history.base, "")
      this.$root.setDataAnimateFalse(".js-vendors ")

      Vue.http.get(`templates${path}`, { params: to.query }).then(
        data => {
          next()
          setTimeout(() => {
            this.template = data.data
            this.newRows[this.currentFormName] = []
            this.setPagination()
            this.disableLoadMore = false
          }, 500)
        },
        () => {
          this.disableLoadMore = false
          next("/404")
        }
      )
    }
  },
  beforeRouteEnter,
  render(createElement) {
    return Vue.compile(this.template).render.call(this, createElement)
  },
}



// WEBPACK FOOTER //
// ./src/templates/pages/questionnaires/view/index.js